import * as React from "react";
import { cn } from "@/lib/utils";

export interface FormFieldProps {
  label?: React.ReactNode;
  required?: boolean;
  hint?: React.ReactNode;
  error?: React.ReactNode;
  htmlFor?: string;
  className?: string;
  children: React.ReactNode;
}

/** Label + control wrapper with the v2026 uppercase label style. */
export const FormField: React.FC<FormFieldProps> = ({
  label,
  required,
  hint,
  error,
  htmlFor,
  className,
  children,
}) => (
  <div className={cn("space-y-1.5", className)}>
    {label && (
      <label
        htmlFor={htmlFor}
        className="block text-[11px] font-semibold uppercase tracking-[0.04em] text-gray-600"
      >
        {label}
        {required && <span className="ml-0.5 text-error-600">*</span>}
      </label>
    )}
    {children}
    {error ? (
      <p className="text-[11px] text-error-600">{error}</p>
    ) : hint ? (
      <p className="text-[11px] text-gray-500">{hint}</p>
    ) : null}
  </div>
);

export default FormField;
